interface Plural {
  one: string; // один банк
  few: string; // три банка
  many: string; // десять банков
  other?: string; // 0.5 банка
}

/**
 * Функция для плюрализации (склонения слова в зависимости от количества)
 * @param count количество
 * @param words варианты слова во множественном и единственном числе
 * @returns Возвращает слово в нужном склонении
 */

export const plural = (count: number, words: Plural) => {
  const rules = new Intl.PluralRules("ru-RU"); // правила плюрализации для русского языка
  const pluralKey = rules.select(count) as keyof Plural; // возвращает ключ для плюрализации (one, few, many...)

  return words[pluralKey] || words.one;
};
